import React, { ReactNode } from "react";
import { style } from "typestyle";

// @ts-ignore
import cn from "classnames";

interface Props {
  label: string;
  icon?: ReactNode;
  href?: string;
  onClick?: () => void;
}

export default function(props: Props) {
  const { label, icon, href, onClick } = props;

  if (href) {
    return (
      <a href={href} target={"_blank"} className={navButtonCN(true)}>
        {icon && <div className={navButtonIconCN}>{icon}</div>}
        <span>{label}</span>
      </a>
    );
  }

  return (
    <div className={navButtonCN(!!onClick)} onClick={onClick || (() => {})}>
      {icon && <div className={navButtonIconCN}>{icon}</div>}
      <span>{label}</span>
    </div>
  );
}

const navButtonCN = (isClickable: boolean) =>
  style({
    height: "100%",
    display: "flex",
    alignItems: "center",
    fontSize: "20px",
    fontWeight: 300,
    color: "white",
    cursor: isClickable ? "pointer" : "auto",
    textDecoration: "none",
  });

const navButtonIconCN = style({
  width: "24px",
  height: "24px",
  marginRight: "16px",
  cursor: "pointer",
  boxSizing: "content-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
